// extracted by mini-css-extract-plugin
module.exports = {"root":"AddressesSetup_root__2u4Ph","filterWrap":"AddressesSetup_filterWrap__2umO8","contentWrapper":"AddressesSetup_contentWrapper__6Hfw2"};